import { AVATAR_PLACEHOLDER_URL } from '../const';

export const getUserAvatarProps = (
  user: { name?: string; surnames?: string; avatarUrl?: string; isPlaceholder?: boolean } | undefined,
) => {
  if (user?.avatarUrl) return { image: user?.avatarUrl };
  if (!user?.name || !user?.surnames || user?.isPlaceholder) return { image: AVATAR_PLACEHOLDER_URL };
  return { label: `${user?.name?.charAt(0)}${user?.surnames?.charAt(0)}` };
};
